import React, { useRef, useEffect, useState } from "react";
import { shallowEqual, useSelector, connect, useDispatch } from "react-redux";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as auth from "./authRedux";
import { getUserByToken } from "./authCrud";

function AuthInit(props) {
  const didRequest = useRef(false);
  const dispatch = useDispatch();
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const { token } = useSelector(
    ({ auth }) => ({
      token: auth.token,
    }),
    shallowEqual
  );

  // We should request user by token before rendering the application
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const { data: user } = await getUserByToken();
          const token = user.data.active_token;
          props.login(token);
          dispatch(props.fulfillUser(user));

          localStorage.setItem(
            "pagination",
            user.data.active_pagination === 0 ? 10 : user.data.active_pagination
          );
          localStorage.setItem("formatDate", user.data.active_dateformat);
          localStorage.setItem("digitGrouping", user.data.active_digitgrouping);
          localStorage.setItem("coBranding", user.data.co_branding);
          localStorage.setItem("username", user.data.username);
        }
      } catch (error) {
        console.error(error);
        if (!didRequest.current) {
          dispatch(props.logout());
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if (token) {
      requestUser();
    } else {
      dispatch(props.fulfillUser(undefined));
      setShowSplashScreen(false);
    }
    // eslint-disable-next-line
  }, []);

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>;
}

export default connect(null, auth.actions)(AuthInit);
